import { render, staticRenderFns } from "./base-form.vue?vue&type=template&id=22b6b7b9&scoped=true&"
import script from "./base-form.vue?vue&type=script&lang=js&"
export * from "./base-form.vue?vue&type=script&lang=js&"
import style0 from "./base-form.vue?vue&type=style&index=0&id=22b6b7b9&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b6b7b9",
  null
  
)

export default component.exports